import {
  DynamicFormInputType,
  FormInputTypes,
} from '@components/_old/dynamicForm';
import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';
import { isEmpty } from '@utils/validationUtils';

export const initialValues = {
  businessPartnerDetails: {
    creditLimitCurrency: '',
    creditLimit: 0,
    gracePeriod: 0,
  },
};

export const drawerSections: IDynamicFormWidgetSection[] = [
  {
    inputs: {
      creditLimitCurrency: {
        name: 'creditLimitCurrency',
        title: 'Credit Limit Currency',
        type: FormFieldType.select,
        placeholder: 'Credit Limit Currency',
        value: !isEmpty(
          initialValues.businessPartnerDetails.creditLimitCurrency
        )
          ? initialValues.businessPartnerDetails.creditLimitCurrency
          : '',
        required: true,
        injectGlobalLov: {
          type: 'currency',
          value: 'Id',
          display: 'Title',
        },
      },
      creditLimit: {
        name: 'creditLimit',
        title: 'Credit Limit',
        type: FormFieldType.currency,
        placeholder: 'Credit Limit',
        value: initialValues.businessPartnerDetails.creditLimit,
        required: true,
      },
      gracePeriod: {
        name: 'gracePeriod',
        title: 'Grace Period (in days)',
        type: FormFieldType.number,
        placeholder: 'Grace Period (in days)',
        value: initialValues.businessPartnerDetails.gracePeriod,
        required: true,
      },
    },
  },
];
